import * as types from './mutation-types';
import { stateToReset } from './state';

export default {
  [types.SET_PURCHASE_COLLECTION](state, payload) {
    state.purchaseCollection = payload;
  },
  [types.SET_SUMMARY_PURCHASES](state, payload) {
    state.summaryPurchases = payload;
  },
  [types.SET_PAGINATION_PURCHASE](state, payload) {
    state.paginationPurchase = payload;
  },
  [types.SET_PURCHASE_TO_SAVE](state) {
    state.purchase = {
      ...state.purchase,
      taxCalc: { ...state.taxCalc },
      taxInformation: { ...state.taxInformation },
      linkedDocuments: { ...state.linkedDocuments },
      supplierInformation: { ...state.supplierInformation },
      products: { ...state.products },
      transport: { ...state.transport },
      payments: { ...state.payments },
    };
  },
  [types.SET_PURCHASE_FOR_EDIT](state, data) {
    state.purchase = data;
    state.taxInformation = {
      ...state.taxInformation,
      ...data.taxInformation,
    };
    state.linkedDocuments = {
      ...state.linkedDocuments,
      ...data.linkedDocuments,
    };
    state.supplierInformation = {
      ...state.supplierInformation,
      ...data.supplierInformation,
    };
    state.products = {
      ...state.products,
      ...data.products,
    };
    state.taxCalc = {
      ...state.taxCalc,
      ...data.taxCalc,
    };
    state.transport = {
      ...state.transport,
      ...data.transport,
    };
    state.payments = {
      ...state.payments,
      ...data.payments,
    };
  },
  [types.RESET_PURCHASE](state) {
    state.purchase = stateToReset().purchase;
    state.taxCalc = stateToReset().purchase.taxCalc;
    state.taxInformation = stateToReset().purchase.taxInformation;
    state.linkedDocuments = stateToReset().purchase.linkedDocuments;
    state.supplierInformation = stateToReset().purchase.supplierInformation;
    state.products = stateToReset().purchase.products;
    state.transport = stateToReset().purchase.transport;
    state.payments = stateToReset().purchase.payments;
    state.importedInvoice = stateToReset().importedInvoice;
    state.productOfPurchaseOnFiscalEdit = stateToReset().productOfPurchaseOnFiscalEdit;
    state.importedInvoiceFormData = stateToReset().importedInvoiceFormData;
  },
  [types.SET_PRODUCT_OF_PURCHASE_ON_FISCAL_EDIT](state, payload) {
    state.productOfPurchaseOnFiscalEdit = payload;
  },
  [types.SET_UNIT_OF_MEASURE](state, payload) {
    state.productOfPurchaseOnFiscalEdit.productData.unitOfMeasure = payload;
  },
  [types.SET_TOTAL_PURCHASE](state, payload) {
    state.taxCalc.vNF = payload ?? 0;
  },
  [types.SET_REMAINDER](state, payload) {
    state.payments.remainder = payload ?? 0;
  },
  [types.SET_IMPORTED_INVOICE](state, payload) {
    state.importedInvoice = {
      ...state.importedInvoice,
      ...payload,
    };
  },
  [types.SET_PAYMENT](state, payload) {
    state.payments.payment = payload;
  },
  [types.SET_INSTALLMENTS_RANGE](state, payload) {
    state.payments.range = payload;
  },
  [types.SET_LINKED_PRODUCTS](state, payload) {
    state.importedInvoice.products.productOfPurchaseCollection = payload;
  },
  [types.SET_LINKED_DOCUMENTS](state, payload) {
    state.importedInvoice.linkedDocuments.linkedDocumentCollection = payload;
  },
  [types.SET_CFOP_COLLECTION](state, payload) {
    state.cfopCollection = payload;
  },
  [types.SET_MATCHED_CFOP_FOR_PURCHASE_TAX_INFORMATION](state, payload) {
    state.taxInformation.natureza.cfop = {
      ...state.taxInformation.natureza.cfop,
      ...payload,
    };
  },
  [types.SET_MATCHED_CFOP_FOR_PRODUCT_PURCHASE](state, payload) {
    state.matchedCfopForProductPurchase = payload;
  },
  [types.SET_NATUREZA_ERROR](state, error) {
    state.purchase.taxInformation.natureza.error = error;
  },
  [types.SET_SUPPLIER](state, payload) {
    state.supplierInformation.supplier = payload;
  },
  [types.SET_SUPPLIER_ERROR](state, error) {
    state.purchase.supplierInformation.supplier.error = error;
  },
  [types.SET_SHIPPING_COMPANY](state, payload) {
    state.transport.shippingCompany = payload;
  },
  [types.SET_DECIMAL_CONFIGURATION](state, payload) {
    state.purchaseParams.decimalConfiguration = payload;
  },
  [types.SET_PRODUCT_ON_PURCHASE_COLLECTION](state, payload) {
    state.products.productOfPurchaseCollection[payload.originalIndex] = {
      ...payload.data,
    };
  },
  [types.SET_CFOP_FOR_PRODUCT](state, payload) {
    state.productOfPurchaseOnFiscalEdit.fiscal.values.cfop = payload;
  },
  [types.SET_CSOSN_FOR_PRODUCT](state, payload) {
    state.productOfPurchaseOnFiscalEdit.fiscal.values.csosn = payload;
  },
  [types.SET_CENQ_FOR_PRODUCT](state, payload) {
    state.productOfPurchaseOnFiscalEdit.fiscal.values.cenq = payload;
  },
  [types.SET_ORIGEM_FOR_PRODUCT](state, payload) {
    state.productOfPurchaseOnFiscalEdit.fiscal.values.origem = payload;
  },
  [types.SET_CST_FOR_PRODUCT](state, payload) {
    state.productOfPurchaseOnFiscalEdit.fiscal.values.cst = payload;
  },
  [types.SET_CST_IPI_FOR_PRODUCT](state, payload) {
    state.productOfPurchaseOnFiscalEdit.fiscal.values.cstIpi = payload;
  },
  [types.SET_CST_PIS_FOR_PRODUCT](state, payload) {
    state.productOfPurchaseOnFiscalEdit.fiscal.values.cstPis = payload;
  },
  [types.SET_CST_COFINS_FOR_PRODUCT](state, payload) {
    state.productOfPurchaseOnFiscalEdit.fiscal.values.cstCofins = payload;
  },
  [types.SET_IMPORTED_INVOICE_FORM_DATA](state, payload) {
    state.importedInvoiceFormData = payload;
  },
  [types.SET_SELECTED_NATUREZA](state, payload) {
    state.selectedNatureza = payload;
  },
  [types.SET_TOTAL_CALC_PURCHASE](state, data) {
    state.products = {
      ...state.products,
      ...data.products,
    };
    state.taxCalc = {
      ...state.taxCalc,
      ...data.taxCalc,
    };
  },
};
